import Header from "./Header"
import "../Myprojects.css";
import api from "views/auth/Api";
import React, { useState,useEffect } from "react";
import {
  columnsDataDevelopment,
  columnsDataCheck,
  columnsDataColumns,
  columnsDataComplex,
} from "../../tables/variables/columnsData";
import tableDataColumns from "../../tables/variables/tableDataColumns.json";
import ColumnsTable from "../../tables/components/ColumnsTable";



const Feedback = ({data}) => {
      const [tableData , setTableData] = useState([]); 
      useEffect(() => {
              setTableData(data.submissions)
              // else setTableData(tableDataColumns)
        }, [data]);
    
  
  return (
        <div className="flex justify-center">
      {/* <Header /> */}
      {/* <h2 className="h2Feedback">Assignments & Submissions</h2> */}
      <div className=" h-full feedBackTable">
        <ColumnsTable
          columnsData={columnsDataColumns}
          tableData={tableData}
        />
      </div>
    </div>
  );
};

export default Feedback;
